import React from 'react';
import FieldErrors from '../ErrorComponents/FieldErrors/FieldErrors';
import HelperText from './HelperText';

export default class TextArea extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			style,
			placeholder,
			name,
			value,
			onChange,
			helperText,
			fieldErrors
		} = this.props;

		return (
			<div className="row">
				<div className="col-12">
					<div className="TextArea">
						<textarea
							type="text"
							style={style}
							className="p-3"
							placeholder={placeholder}
							name={name}
							value={value || ''}
							onChange={onChange}
						/>
					</div>
					{fieldErrors && fieldErrors.hasOwnProperty(name) ? (
						<FieldErrors fieldName={name} fieldErrors={fieldErrors} />
					) : (
						<HelperText>{helperText}</HelperText>
					)}
				</div>
			</div>
		);
	}
}
